"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizClientDatasourceList = exports.datasourceListHeaderTestId = exports.datasourceListSectionTestId = void 0;
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var ViewerPaneStyles_1 = require("./ViewerPaneStyles");
var VizClientDatasourceElement_1 = require("./VizClientDatasourceElement");
var datasourceListMaxHeight = 200;
exports.datasourceListSectionTestId = 'data-details-datasource-list-section';
exports.datasourceListHeaderTestId = 'data-details-datasources-with-count-header';
/** A widget to display a list of datasources associated with the current sheet */
function VizClientDatasourceList(props) {
    var shouldHaveMaxHeightOnDatasourceList = props.datasources.length > 2;
    return (React.createElement(ViewerPaneStyles_1.DatasourceListSection, { "data-tb-test-id": exports.datasourceListSectionTestId },
        React.createElement(ViewerPaneStyles_1.DatasourcesSectionHeader, { "data-tb-test-id": exports.datasourceListHeaderTestId }, Localize_1.Messages.DatasourcesWithCount({ count: Localize_1.Formatters.formatCount(props.datasources.length) })),
        React.createElement(ViewerPaneStyles_1.DatasourceListBody, { style: shouldHaveMaxHeightOnDatasourceList ?
                { maxHeight: datasourceListMaxHeight } :
                { width: ViewerPaneStyles_1.dataDetailsContentWidth }, "data-tb-test-id": 'data-details-datasource-list-body' }, props.datasources.map(function (datasource) {
            return React.createElement(VizClientDatasourceElement_1.VizClientDatasourceElement, { key: datasource.id, datasource: datasource, workbookVizportalUrlId: props.workbookVizportalUrlId });
        }))));
}
exports.VizClientDatasourceList = VizClientDatasourceList;
//# sourceMappingURL=VizClientDatasourceList.js.map